import { COLORS } from '@/styles/colors';
import { bodySmall, poppinsMediumFont } from '@/styles/typography';
import styled from 'styled-components';

export const TabWrapper = styled.div<{ isActive: boolean; disabled?: boolean }>`
  padding: 8px 12px;
  ${bodySmall};
  ${poppinsMediumFont};
  cursor: pointer;
  border-bottom: 3px solid transparent;

  ${({ isActive }) =>
    isActive &&
    `
      border-color: ${COLORS.green[500]};
    `};

  ${({ disabled }) =>
    disabled &&
    `
      color: ${COLORS.grey[600]};
      pointer-events: none;
      border-bottom: 3px solid transparent;
    `};
`;
